/**
 * Forms drawer mount point for the Design tab.
 */

import { eventBus } from '../../core/events.js';

export function renderFormsContent(bodyEl, { panel }) {
  if (!bodyEl || !panel) return () => {};
  panel._renderFormsDrawer(bodyEl);
  const off = eventBus.on('state-changed', () => panel._refreshFormsDrawer(bodyEl));
  return () => {
    off?.();
    panel._teardownDesignBoardCleanups?.('forms');
  };
}
